import { styled } from '@linaria/react';

export const Root = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 4px;
  margin-top: 16px;
`;
